/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { StyledText } from "../../assets/typography/typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Organization } from "../../model/Organization";

type Props = {
  organization: Organization;
  onOrganizationSelect: (organizationKeyName: string) => void;
  chosenOrganizationName?: string;
};

const wrapperStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 4px;
  padding-bottom: 4px;
`;

export const TopbarDropdownOrganizationItem = ({
  organization,
  onOrganizationSelect,
  chosenOrganizationName,
}: Props) => {
  return (
    <div
      onClick={() => onOrganizationSelect(organization.keyName)}
      css={wrapperStyle}
    >
      <StyledText className="bodyTextRegular mb-0">
        {organization.name}
      </StyledText>
      {chosenOrganizationName === organization.keyName && (
        <StyledText className="bodyTextSemibold mb-0">
          <FontAwesomeIcon icon={solid("eye")} />
        </StyledText>
      )}
    </div>
  );
};
